import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Layout,
  Input,
  Button,
  Form,
  Card,
  Divider,
  Table,
  MenuProps,
  Dropdown,
  DatePicker,
  Modal,
  Popover,
  Tag,
  Image,
} from "antd";
import Loader from "../../components/Loader/Loader";
import "./OverviewPage.css";
import Sidebar from "../../components/Sidebar/Sidebar";
import Header from "../../components/Header/Header";
import Copyright from "../../components/Copyright/Copyright";
import {
  getMetalsService,
  postBillsToOverviewService,
  getOverviewService,
  getSuppliersService,
  getMaterialService,
  getCategoriesService,
  getBuyersService,
} from "./OverviewPageService";
import { removeTokenFromCookies } from "../../utils/cookies";
import Cookies from "universal-cookie";
import { ControlFilled, EditOutlined, ExclamationOutlined, MoreOutlined } from "@ant-design/icons";
import moment from "moment";

const { Content } = Layout;

export interface OverviewPageInterface {}

const OverviewPage = (props: OverviewPageInterface) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [loading, setLoading] = useState(false);
  const [metals, setMetals] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalOverview, setTotalOverview] = useState(0);
  const [metalsMap, setMetalsMap] = useState({}) as any;
  const [categories, setCategories] = useState([]) as any;
  const [isAddToOverviewModalOpen, setAddToOverviewModalOpen] = useState(false);
  const [currDate, setCurrDate] = useState("");
  const [overviewList, setOverviewList] = useState([]) as any;
  const [suppliers, setSuppliers] = useState([]);
  const [buyers, setBuyers] = useState([]);
  const [overviewDetailsTableData, setOverviewDetailsTableData] = useState([]) as any;
  const navigate = useNavigate();
  const cookies = new Cookies();
  const currOffice = cookies.get("CURR_OFFICE");

  const overviewColumns = [
    {
      title: "Item Number",
      key: "index",
      align: "center" as const,
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Purchase Date",
      key: "purchaseDate",
      align: "center" as const,
      render: (record: any) => new Date(record.purchaseCreatedTimestamp).toLocaleDateString("en-GB"),
    },
    {
      title: "Purchase Time",
      key: "time",
      align: "center" as const,
      render: (record: any) =>
        new Date(record.purchaseCreatedTimestamp).toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        }),
    },
    {
      title: "Office",
      key: "office",
      align: "center" as const,
      render: (record: any) => {
        let officeNameFormat: any = {
          pg: "Penang (PG)",
          bw: "Butterworth (BW)",
        };
        return (
          <div style={{ display: "flex" }}>
            <div className={`${record.office}-square-icon`}></div>
            <div> {officeNameFormat[record.office]}</div>
          </div>
        );
      },
    },
    {
      title: "Supplier",
      key: "supplier",
      align: "left" as const,
      render: (record: any) => getSupplierDisplayName(record.supplierID),
    },

    {
      title: "Materials",
      key: "totalNumMaterials",
      align: "center" as const,
      render: (record: any) => Number(record.totalNumMaterials),
    },
    {
      title: "Total Net Weight (kg)",
      key: "totalNetWeight",
      align: "center" as const,
      render: (record: any) => Number(record.totalNetWeight).toFixed(1),
    },
    {
      title: "Purchase Cost (RM)",
      key: "purchaseCost",
      align: "center" as const,
      render: (record: any) => Number(record.purchaseCost).toFixed(2),
    },
    {
      title: "Sold Revenue (RM)",
      key: "purchaseCost",
      align: "center" as const,
      render: (record: any) => (record.soldRevenue == 0 ? "-" : Number(record.soldRevenue).toFixed(2)),
    },
    {
      title: "Gross Profit (RM)",
      key: "grossProfit",
      align: "center" as const,
      render: (record: any) => (record.grossProfit == 0 ? "-" : Number(record.grossProfit).toFixed(2)),
    },
    {
      title: "Gross Profit Percentage",
      key: "grossProfitPercentage",
      align: "center" as const,
      render: (record: any) => {
        let profitPercentageColor = "grey";
        let profitPercentage = Number((Number(record.grossProfit) / Number(record.purchaseCost)) * 100).toFixed(0);
        if (Number(profitPercentage) < 0) profitPercentageColor = "red";
        if (Number(profitPercentage) > 0 && Number(profitPercentage) <= 10) profitPercentageColor = "volcano";
        if (Number(profitPercentage) > 10 && Number(profitPercentage) <= 30) profitPercentageColor = "orange";
        if (Number(profitPercentage) > 30 && Number(profitPercentage) <= 50) profitPercentageColor = "gold";
        if (Number(profitPercentage) > 50 && Number(profitPercentage) <= 80) profitPercentageColor = "lime";
        if (Number(profitPercentage) > 80) profitPercentageColor = "green";
        return Number(profitPercentage) > 0 ? (
          <Tag color={profitPercentageColor}>{`${Number(profitPercentage).toFixed(0)} %`}</Tag>
        ) : (
          "-"
        );
      },
    },
    Table.EXPAND_COLUMN,
    {
      title: "All Sold",
      align: "center" as const,
      render: (record: any) =>
        record.allMaterialsSold ? (
          "Yes"
        ) : (
          <div style={{ color: "red" }}>
            <ExclamationOutlined />
            No
          </div>
        ),
    },
    {
      title: "Options",
      key: "options",
      align: "center" as const,
      render: (record: any) => {
        const userRole = cookies.get("USER_ROLE");
        let items: MenuProps["items"] = [];
        // items.push({ key: "edit", label: "Add/Edit Buyer Info", icon: <EditOutlined /> });
        return (
          <Dropdown
            menu={{
              items,
              onClick: ({ key }) => {
                // if (key === "edit") openAddEditBuyerInfo(record);
              },
            }}
            trigger={["click"]}
          >
            <a onClick={(e) => e.preventDefault()}>
              <MoreOutlined style={{ fontSize: "24px" }} />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  const overviewDetailsColumns = [
    {
      title: "Item Number",
      key: "index",
      align: "center" as const,
      render: (text: any, record: any, index: any) => index + 1,
    },
    // {
    //   title: "Office",
    //   key: "office",
    //   align: "center" as const,
    //   render: (record: any) => {
    //     let officeNameFormat: any = {
    //       pg: "Penang (PG)",
    //       bw: "Butterworth (BW)",
    //     };
    //     return (
    //       <div style={{ display: "flex" }}>
    //         <div className={`${record.office}-square-icon`}></div>
    //         <div> {officeNameFormat[record.office]}</div>
    //       </div>
    //     );
    //   },
    // },
    {
      title: "Image",
      key: "index",
      render: (record: any) => (
        <>
          <Image
            height={50}
            width={50}
            src={record.scaleImageURL || record.imageURL}
            preview={{
              toolbarRender: () => (
                <>
                  <h1 style={{ color: "#000000" }}>{metalsMap[record.metalID].displayName}</h1>
                  <h3 style={{ color: "#000000" }}>Raw Weight: {Number(record.rawWeight).toFixed(1)} kg</h3>
                </>
              ),
            }}
          />
          <Image
            height={50}
            width={50}
            src={record.materialImageURL}
            preview={{
              toolbarRender: () => (
                <>
                  <h1 style={{ color: "#000000" }}>{metalsMap[record.metalID].displayName}</h1>
                  <h3 style={{ color: "#000000" }}>Raw Weight: {Number(record.rawWeight).toFixed(1)} kg</h3>
                </>
              ),
            }}
          />
        </>
      ),
      align: "center" as const,
    },
    {
      title: "Material Category",
      key: "name",
      align: "left" as const,
      render: (record: any) => {
        const categoryID = metalsMap[record.metalID]?.categoryID;
        const category = categories.find((category: any) => category.categoryID === categoryID);
        return (
          <div style={{ display: "flex" }}>
            <div className={`${category.name.toLowerCase().replace(" ", "-")}-square-icon`}></div>
            <div> {category !== undefined ? category.name.replace("Stainless", "") : ""}</div>
          </div>
        );
      },
    },
    {
      title: "Material Name",
      key: "name",
      align: "left" as const,
      render: (record: any) =>
        metalsMap[record.metalID] !== undefined ? metalsMap[record.metalID].displayName : record.metalID,
    },
    {
      title: "Margin (RM)",
      key: "margin",
      align: "center" as const,
      render: (record: any) => {
        let profitMarginColor = "grey";
        if (Number(record.margin) < 0.0) profitMarginColor = "red";
        if (Number(record.margin) > 0.0 && Number(record.margin) <= 0.3) profitMarginColor = "volcano";
        if (Number(record.margin) > 0.3 && Number(record.margin) <= 0.5) profitMarginColor = "orange";
        if (Number(record.margin) > 0.5 && Number(record.margin) <= 0.8) profitMarginColor = "gold";
        if (Number(record.margin) > 0.8 && Number(record.margin) <= 1.0) profitMarginColor = "lime";
        if (Number(record.margin) > 1.0) profitMarginColor = "green";
        return record.margin == 0 ? "-" : <Tag color={profitMarginColor}>{Number(record.margin).toFixed(2)}</Tag>;
      },
    },
    // {
    //   title: "Purchase Date",
    //   key: "purchaseDate",
    //   align: "center" as const,
    //   render: (record: any) => new Date(record.purchaseCreatedTimestamp).toLocaleDateString("en-GB"),
    // },
    {
      title: "Net Weight (kg)",
      key: "netWeight",
      align: "center" as const,
      render: (record: any) => Number(record.netWeight).toFixed(1),
    },
    {
      title: "Purchase Price (RM)",
      key: "purchasePrice",
      align: "center" as const,
      render: (record: any) => Number(record.purchasePrice).toFixed(2),
    },
    {
      title: "Cost (RM)",
      key: "purchaseCost",
      align: "center" as const,
      render: (record: any) => Number(record.purchaseCost).toFixed(2),
    },
    // {
    //   title: "Supplier",
    //   key: "supplier",
    //   align: "center" as const,
    //   render: (record: any) => getSupplierDisplayName(record.supplierID),
    // },
    {
      title: "Sold Date",
      key: "soldDate",
      align: "center" as const,
      render: (record: any) =>
        record.soldTimestamp !== null ? new Date(record.soldTimestamp).toLocaleDateString("en-GB") : "-",
    },
    {
      title: "Buyer",
      key: "buyer",
      align: "center" as const,
      render: (record: any) => (record.buyerID ? getBuyerDisplayName(record.buyerID) : "-"),
      //check buyerID
    },
    {
      title: "Selling Price (RM)",
      key: "purchasePrice",
      align: "center" as const,
      render: (record: any) => (record.sellingPrice === 0 ? "-" : Number(record.sellingPrice).toFixed(2)),
    },
    {
      title: "Revenue (RM)",
      key: "purchaseCost",
      align: "center" as const,
      render: (record: any) => (record.revenue === 0 ? "-" : Number(record.revenue).toFixed(2)),
    },
    // {
    //   title: "Gross Profit (RM)",
    //   key: "grossProfit",
    //   align: "center" as const,
    //   render: (record: any) => (record.grossProfit === 0 ? "-" : Number(record.grossProfit).toFixed(2)),
    // },
    {
      title: "Gross Profit (RM)",
      key: "grossProfit",
      align: "center" as const,
      render: (record: any) =>
        record.revenue != 0 ? Number(Number(record.revenue) - Number(record.purchaseCost)).toFixed(2) : "-",
    },
    {
      title: "Days in Inv",
      key: "daysInInv",
      align: "center" as const,
      render: (record: any) => getNumDaysInInv(record),
    },
    {
      title: "Manual Entry",
      key: "manualEntry",
      align: "center" as const,
      render: (record: any) =>
        record.manualEntry ? (
          <>
            <ControlFilled style={{ fontSize: "20px", color: "orange", marginRight: "5px" }} />
            Yes
          </>
        ) : (
          <>
            <ControlFilled style={{ fontSize: "20px", color: "green", marginRight: "5px" }} />
            No
          </>
        ),
    },
    {
      title: "Gross Profit Percentage",
      key: "grossProfitPercentage",
      align: "center" as const,
      render: (record: any) => {
        let profitPercentageColor = "grey";
        let profitPercentage = Number((Number(record.grossProfit) / Number(record.purchaseCost)) * 100).toFixed(0);
        if (Number(profitPercentage) < 0) profitPercentageColor = "red";
        if (Number(profitPercentage) > 0 && Number(profitPercentage) <= 10) profitPercentageColor = "volcano";
        if (Number(profitPercentage) > 10 && Number(profitPercentage) <= 30) profitPercentageColor = "orange";
        if (Number(profitPercentage) > 30 && Number(profitPercentage) <= 50) profitPercentageColor = "gold";
        if (Number(profitPercentage) > 50 && Number(profitPercentage) <= 80) profitPercentageColor = "lime";
        if (Number(profitPercentage) > 80) profitPercentageColor = "green";
        return Number(profitPercentage) > 0 ? (
          <Tag color={profitPercentageColor}>{`${Number(profitPercentage).toFixed(0)} %`}</Tag>
        ) : (
          "-"
        );
      },
    },
    {
      title: "Options",
      key: "options",
      align: "center" as const,
      render: (record: any) => {
        const userRole = cookies.get("USER_ROLE");
        let items: MenuProps["items"] = [];
        // items.push({ key: "edit", label: "Add/Edit Buyer Info", icon: <EditOutlined /> });
        return (
          <Dropdown
            menu={{
              items,
              onClick: ({ key }) => {
                // if (key === "edit") openAddEditBuyerInfo(record);
              },
            }}
            trigger={["click"]}
          >
            <a onClick={(e) => e.preventDefault()}>
              <MoreOutlined style={{ fontSize: "24px" }} />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  useEffect(() => {
    navToSelectOffice();
    getSuppliers();
    getBuyers();
    getMetals();
    getCategories();
  }, []);

  useEffect(() => {
    // getOverview(currentPage, suppliersSelectedOptions, dateRangeFilter);
    getOverview(currentPage);
  }, [metals]);

  const navToSelectOffice = () => {
    if (currOffice === "" || currOffice === undefined || currOffice === null) navigate("/");
  };

  const toggleSidebar = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  const navToLogin = () => {
    navigate("/login");
  };

  const getMetals = async () => {
    try {
      setLoading(true);
      const res = await getMetalsService();
      setMetals(res.data);
      const options: any = [];
      const currMetalsMap: any = {};
      res.data.forEach((metal: any) => {
        currMetalsMap[metal.metalID] = { ...metal };
        options.push({
          label: metal.displayName,
          value: metal.metalID,
        });
      });
      setMetalsMap(currMetalsMap);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getMetals error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getCategories = async () => {
    try {
      setLoading(true);
      const res = await getCategoriesService();
      setMetals(res.data);
      const options: any = [];
      const categories: any = [];
      res.data.forEach((category: any) => {
        console.log("categories", categories);
        categories.push(category);
      });
      setCategories(categories);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getMetals error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getSuppliers = async () => {
    try {
      setLoading(true);
      const res = await getSuppliersService();
      const suppliersData: any = [...res.data.pgSuppliers, ...res.data.bwSuppliers];
      setSuppliers(suppliersData);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getSuppliers error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getBuyers = async () => {
    try {
      setLoading(true);
      const res = await getBuyersService();
      const buyersData: any = [...res.data.pgBuyers, ...res.data.bwBuyers];
      setBuyers(buyersData);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getBuyers error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getNumDaysInInv = (record: any) => {
    let currentDate: any = new Date();
    let purchaseDate: any = new Date(record.purchaseCreatedTimestamp);
    let daysDifference: any = currentDate - purchaseDate;
    let daysInInv = Math.ceil(daysDifference / (1000 * 3600 * 24));
    if (record.soldTimestamp !== null && record.soldTimestamp !== undefined) {
      let soldDate: any = new Date(record.soldTimestamp);
      daysDifference = soldDate - purchaseDate;
      daysInInv = Math.ceil(daysDifference / (1000 * 3600 * 24));
    }
    return daysInInv;
  };

  const openAddToOverviewModal = () => {
    setAddToOverviewModalOpen(true);
  };

  const closeAddToOverViewModal = () => {
    setCurrDate("");
    setAddToOverviewModalOpen(false);
  };

  const getSupplierDisplayName = (supplierID: any) => {
    const supplierInfo = suppliers.find((supplier: any) => supplier.supplierID === supplierID);
    let supplierDisplayInfo = "";
    let popoverContent = <></>;
    if (
      supplierInfo !== undefined &&
      supplierInfo["companyName"] !== undefined &&
      supplierInfo["companyName"] !== "" &&
      supplierInfo["name"] !== undefined &&
      supplierInfo["name"] !== ""
    ) {
      supplierDisplayInfo = supplierInfo["companyName"] + " (" + supplierInfo["name"] + ")";
      popoverContent = (
        <div>
          <p>Name: {supplierInfo["name"]}</p>
          <p>Company: {supplierInfo["companyName"]}</p>
          {supplierInfo["identificationCardNumber"] !== "" && (
            <p>IC Number: {supplierInfo["identificationCardNumber"]}</p>
          )}
          {supplierInfo["passportNumber"] !== "" && <p>Passport Number: {supplierInfo["passportNumber"]}</p>}
        </div>
      );
    } else if (
      supplierInfo !== supplierInfo &&
      supplierInfo["companyName"] !== undefined &&
      supplierInfo["companyName"] !== ""
    ) {
      supplierDisplayInfo = supplierInfo["companyName"];
      popoverContent = (
        <div>
          <p>Company: {supplierInfo["companyName"]}</p>
          {supplierInfo["identificationCardNumber"] !== "" && (
            <p>IC Number: {supplierInfo["identificationCardNumber"]}</p>
          )}
          {supplierInfo["passportNumber"] !== "" && <p>Passport Number: {supplierInfo["passportNumber"]}</p>}
        </div>
      );
    } else if (supplierInfo !== undefined && supplierInfo["name"] !== undefined && supplierInfo["name"] !== "") {
      supplierDisplayInfo = supplierInfo["name"];
      popoverContent = (
        <div>
          <p>Name: {supplierInfo["name"]}</p>
          {supplierInfo["identificationCardNumber"] !== "" && (
            <p>IC Number: {supplierInfo["identificationCardNumber"]}</p>
          )}
          {supplierInfo["passportNumber"] !== "" && <p>Passport Number: {supplierInfo["passportNumber"]}</p>}
        </div>
      );
    }
    return <Popover content={popoverContent}>{supplierDisplayInfo}</Popover>;
  };

  const getBuyerDisplayName = (buyerID: any) => {
    const buyerInfo = buyers.find((buyer: any) => buyer.buyerID === buyerID);
    console.log("buyers", buyers);
    console.log("buyerInfo", buyerInfo);
    let buyerDisplayInfo = "";
    let popoverContent = <></>;
    if (
      buyerInfo !== undefined &&
      buyerInfo["companyName"] !== undefined &&
      buyerInfo["companyName"] !== "" &&
      buyerInfo["name"] !== undefined &&
      buyerInfo["name"] !== ""
    ) {
      buyerDisplayInfo = buyerInfo["companyName"] + " (" + buyerInfo["name"] + ")";
      popoverContent = (
        <div>
          <p>Name: {buyerInfo["name"]}</p>
          <p>Company: {buyerInfo["companyName"]}</p>
          {buyerInfo["identificationCardNumber"] !== "" && <p>IC Number: {buyerInfo["identificationCardNumber"]}</p>}
          {buyerInfo["passportNumber"] !== "" && <p>Passport Number: {buyerInfo["passportNumber"]}</p>}
        </div>
      );
    } else if (buyerInfo !== buyerInfo && buyerInfo["companyName"] !== undefined && buyerInfo["companyName"] !== "") {
      buyerDisplayInfo = buyerInfo["companyName"];
      popoverContent = (
        <div>
          <p>Company: {buyerInfo["companyName"]}</p>
          {buyerInfo["identificationCardNumber"] !== "" && <p>IC Number: {buyerInfo["identificationCardNumber"]}</p>}
          {buyerInfo["passportNumber"] !== "" && <p>Passport Number: {buyerInfo["passportNumber"]}</p>}
        </div>
      );
    } else if (buyerInfo !== undefined && buyerInfo["name"] !== undefined && buyerInfo["name"] !== "") {
      buyerDisplayInfo = buyerInfo["name"];
      popoverContent = (
        <div>
          <p>Name: {buyerInfo["name"]}</p>
          {buyerInfo["identificationCardNumber"] !== "" && <p>IC Number: {buyerInfo["identificationCardNumber"]}</p>}
          {buyerInfo["passportNumber"] !== "" && <p>Passport Number: {buyerInfo["passportNumber"]}</p>}
        </div>
      );
    }
    return <Popover content={popoverContent}>{buyerDisplayInfo}</Popover>;
  };

  const onChangeDate = (date: any, dateString: any) => {
    setCurrDate(dateString);
  };

  const postAddBillsToOverview = async () => {
    try {
      setLoading(true);
      const payload = {
        date: currDate,
      };
      const res = await postBillsToOverviewService(payload);
      setLoading(false);
      console.log("currDate", currDate);
    } catch (e: any) {
      setLoading(false);
      console.error("postAddBillsToOverview error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getOverview = async (pageNumber: Number) => {
    try {
      setLoading(true);
      const filters = {};
      //   suppliers: suppliersFilter,
      //   startDate: dateRangeFilter[0] === null || dateRangeFilter.length === 0 ? "" : dateRangeFilter[0],
      //   endDate: dateRangeFilter[1] === null || dateRangeFilter.length === 0 ? "" : dateRangeFilter[1],
      // };
      const resOverview = await getOverviewService(String(pageNumber), filters);
      setTotalPages(resOverview.data.totalPages);
      setTotalOverview(resOverview.data.totalOverview);
      console.log("resOverview", resOverview);
      const currOverview: any[] = [];
      for (let overview of resOverview.data.overview) {
        overview.key = overview.overviewID;
        // const purchaseID = bill.purchaseID;
        // const resPurchase = await getPurchase(purchaseID);
        // bill.materialIDList = resPurchase?.data.materialIDList;
        currOverview.push(overview);
      }
      setOverviewList([...currOverview]);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getBills error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getMaterial = async (materialID: string) => {
    try {
      setLoading(true);
      const res = await getMaterialService(materialID);
      setLoading(false);
      return res;
    } catch (e: any) {
      setLoading(false);
      console.error("getMaterial error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getOverviewExpandedDetails = async (overviewID: string) => {
    try {
      setLoading(true);
      const currOverview = overviewList.find((overview: any) => overview.overviewID === overviewID);
      const currMaterials: any[] = [];
      for (let materialID of currOverview.materialIDList) {
        const resMaterial: any = await getMaterial(materialID);
        const materialData = resMaterial.data;
        materialData.key = materialData.materialID;
        const currMetal: any = metals.find((metal: any) => metal.metalID === materialData.metalID);
        materialData.displayName = currMetal.displayName;
        currMaterials.push(materialData);
      }
      console.log("currMaterials", currMaterials);
      const newOverviewDetails = [...overviewDetailsTableData];
      const newOverviewDetailsObject = {
        overviewID: overviewID,
        materialsList: currMaterials,
      };
      newOverviewDetails.push(newOverviewDetailsObject);
      setOverviewDetailsTableData([...newOverviewDetails]);
      console.log("newOverviewDetails", newOverviewDetails);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getOverviewExpandedDetails error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const formatOverviewMaterialList = (overviewDetails: any) => {
    let overviewMaterialList: any[] = [];
    overviewDetails.materialsList.forEach((material: any) => {
      const materialIfExists = overviewMaterialList.find(
        (overviewMaterial: any) => material.metalID === overviewMaterial.metalID
      );
      if (materialIfExists) {
        materialIfExists.netWeight = (Number(materialIfExists.netWeight) + Number(material.netWeight)).toFixed(1);
      } else {
        overviewMaterialList.push({ ...material });
      }
    });
    return [...overviewMaterialList];
  };

  const displayOverviewDetails = (overviewID: string) => {
    const currOverview = overviewList.find((overview: any) => overview.overviewID === overviewID);
    const currOverviewDetails = overviewDetailsTableData.find((overview: any) => overview.overviewID === overviewID);
    if (currOverviewDetails === undefined || currOverviewDetails === null) return <></>;
    return (
      <Row justify="center">
        <Col span={16}>
          <Table
            dataSource={formatOverviewMaterialList(currOverviewDetails)}
            columns={overviewDetailsColumns}
            pagination={false}
          />
        </Col>
      </Row>
    );
  };

  return (
    <Layout>
      <Loader loading={loading} />
      <Sidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      <Content>
        <Header toggleSidebar={toggleSidebar} />
        <Row justify="center">
          <Col span={22}>
            <Row>
              <Col span={12}>
                <Row justify="start">
                  <h2 className="average-prices-title">Overview</h2>
                </Row>
              </Col>
              <Col span={12}>
                <Row justify="end" style={{ marginTop: "20px" }}>
                  <Button type="primary" onClick={() => openAddToOverviewModal()}>
                    Add to Overview
                  </Button>
                </Row>
              </Col>
            </Row>
            <Divider style={{ margin: "12px 0" }} />
            <Table
              dataSource={[...overviewList]}
              columns={overviewColumns}
              rowKey={(record: any) => record.key}
              pagination={{
                pageSize: 20,
                total: totalOverview,
                showSizeChanger: false,
                onChange: (page) => {
                  setCurrentPage(page);
                  getOverview(page);
                },
              }}
              expandedRowRender={(record: any) => displayOverviewDetails(record.overviewID)}
              expandIcon={({ expanded, onExpand, record }) =>
                expanded ? (
                  <Button type="default" size="small" onClick={(e) => onExpand(record, e)}>
                    Hide Details
                  </Button>
                ) : (
                  <Button
                    type="default"
                    size="small"
                    onClick={async (e) => {
                      await getOverviewExpandedDetails(record.overviewID);
                      onExpand(record, e);
                    }}
                  >
                    Show Details
                  </Button>
                )
              }
            />
          </Col>
        </Row>
        <Copyright />
      </Content>
      <Modal
        title="Adding Bills to Overview"
        open={isAddToOverviewModalOpen}
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{ style: { display: "none" } }}
        onCancel={closeAddToOverViewModal}
      >
        <Row>
          <Col span={24}>
            <Row style={{ marginBottom: "10px" }}>Select a Date:</Row>
            <Row style={{ marginBottom: "10px" }}>
              <DatePicker
                onChange={onChangeDate}
                showToday
                format={"DD/MM/YYYY"}
                disabledDate={(current) => {
                  let customDate = moment().add(1, "day").format("YYYY-MM-DD");
                  return current && current > moment(customDate, "YYYY-MM-DD");
                }}
              />
            </Row>
            <Row justify="center" style={{ marginTop: "50px" }}>
              <Button
                type="primary"
                onClick={() => postAddBillsToOverview()}
                style={{ marginRight: "20px" }}
                disabled={currDate == "" || currDate == undefined}
              >
                Add Bills to Overview
              </Button>
              <Button onClick={() => closeAddToOverViewModal()}>Cancel</Button>
            </Row>
          </Col>
        </Row>
      </Modal>
    </Layout>
  );
};

export default OverviewPage;
